import React from 'react'
import './SearchFormBar.scss'

// Anything inside this (which inside a SearchForm) get put into a single-row bar at tablet+
const SearchFormBar = ({ children, forceStacked = false }) => {
  return (
    <div className={`SearchFormBar ${forceStacked ? 'force-stacked' : ''}`}>
      {children}
    </div>
  )
}

export default SearchFormBar
